import { makeStyles, Theme } from "@material-ui/core";

export const useStyle = makeStyles((theme: Theme) => ({
    card: {
      height: `calc(100% - ${theme.spacing(2)}px)`,
      '& a': {
        height: '100%',
      },
    },
  }));